module.exports = {
	name: 'MailNotify',
	provides: 'mailNotify',
	main: 'mail_notify.js',
	dependencies: {
		/** @type Logger */
		logger: true,

		/** @type Location */
		location: false,
	}
};
